import React from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";

// Template
import Template from "components/Template/Template";

// Pages
import ProtectedRoute from "./components/ProtectedRoute";
import DetailPage from "./pages/detail/DetailPage";
import HomePage from "./pages/home/HomePage";
import LoginPage from "./pages/login/LoginPage";
import NewTreePage from "./pages/newTree/NewTreePage";
import ReportsPage from "./pages/reports/ReportsPage";
import WateringsPage from "./pages/waterings/WateringsPage";

const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <Template isLoginPage>
              <LoginPage />
            </Template>
          }
        />
        <Route path="/" element={<ProtectedRoute />}>
          <Route index element={<HomePage />} />
          <Route path="new" element={<NewTreePage />} />
          <Route path="detail/:id" element={<DetailPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="reports/:userId" element={<WateringsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
